import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DatePipe } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReturnStruct } from '../../../shared/services/structs/return.struct';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { provideNgxMask } from 'ngx-mask';
import { FabricanteService } from '../../../shared/services/apis/repositorio-tintas/fabricante.service';
import { FabricanteResponse } from '../../../shared/services/responses/repositorio-tintas/fabricante.response';
import { FabricanteRequest } from '../../../shared/services/requests/repositorio-tintas/fabricante.request';
import { MatDialog } from '@angular/material/dialog';
import { TableModalComponent } from '../../../shared/components/table-modal/table-modal.component';
import { BaseService } from '../../../shared/services/apis/repositorio-tintas/base.service';
import { FormulaService } from '../../../shared/services/apis/repositorio-tintas/formula.service';
import { EmbalagemService } from '../../../shared/services/apis/repositorio-tintas/embalagem.service';
import { PigmentoService } from '../../../shared/services/apis/repositorio-tintas/pigmento.service';
import { CorService } from '../../../shared/services/apis/repositorio-tintas/cor.service';
import { ListaBaseResponse } from '../../../shared/services/responses/repositorio-tintas/lista-base.response';
import { ListaFormulaResponse } from '../../../shared/services/responses/repositorio-tintas/lista-formula.response';
import { ListaCorResponse } from '../../../shared/services/responses/repositorio-tintas/lista-cor.response';
import { ListaEmbalagemResponse } from '../../../shared/services/responses/repositorio-tintas/lista-embalagem.response';
import { ListaPigmentoResponse } from '../../../shared/services/responses/repositorio-tintas/lista-pigmento.response';
import { UsuarioAdminResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin.response';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario-admin/usuario-admin.service';
import { UsuarioAdminLoginResponse } from '../../../shared/services/responses/usuario-admin/usuario-admin-login.response';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { tipoArquivoValidator } from '../../../shared/validators/tipo-arquivo.validator';

@Component({
  selector: 'app-fabricante-cadastro',
  imports: [
    MenuComponent,
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatSlideToggleModule,
  ],
  providers: [provideNgxMask(), DatePipe],
  templateUrl: './fabricante-cadastro.component.html',
  styleUrl: './fabricante-cadastro.component.css',
})
export class FabricanteCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private fabricanteService: FabricanteService,
    private baseService: BaseService,
    private formulaService: FormulaService,
    private embalagemService: EmbalagemService,
    private pigmentoService: PigmentoService,
    private usuarioAdminService: UsuarioAdminService,
    private corService: CorService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private datePipe: DatePipe,
    public dialog: MatDialog
  ) {
    this.moduloEnum = ModuloEnum.Tintas;
    this.funcionalidadeEnum = FuncionalidadeEnum.Tintas_Fabricante;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _fabricanteResponse: FabricanteResponse;
  public fileName: string = '';
  public file: File | null = null;
  public idFabricante: number;
  public _paginaAtualModal: number = 0;
  public _ultimaPaginaModal: boolean;

  async ngOnInit(): Promise<void> {
    if (this.activatedRoute.snapshot.paramMap.get('idFabricante'))
      this.idFabricante = parseInt(this.activatedRoute.snapshot.paramMap.get('idFabricante') ?? '');

    this.model = this.formBuilder.group({
      nomeFabricante: new FormControl({ value: '', disabled: true }),
      versao: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      versaoResulth: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      dataHora: new FormControl({ value: '', disabled: true }),
      usuarioAdministriador: new FormControl({ value: '', disabled: true }),
      arquivo: new FormControl({ value: '', disabled: true }, [
        Validators.required,
        tipoArquivoValidator(['.rar']),
      ]),
    });

    if (this.idFabricante) {
      await this.popularDadosFabricante();
    }
  }

  popularDadosFabricante(): void {
    this.fabricanteService.ObterPorId(this.idFabricante ?? 0).subscribe({
      next: async (fabricanteResponse: FabricanteResponse) => {
        if (fabricanteResponse.isError) {
          this.alertService.show('Erro', fabricanteResponse.errorDescription, AlertType.error);
          return;
        }
        this.model.get('nomeFabricante')?.setValue(fabricanteResponse.fabricante.nomeFabricante);
        this.model.get('versao')?.setValue(fabricanteResponse.fabricante.versao);
        this.model.get('versaoResulth')?.setValue(fabricanteResponse.fabricante.versaoResulth);
        this.model
          .get('dataHora')
          ?.setValue(
            this.datePipe.transform(
              new Date(fabricanteResponse.fabricante.datetimeInclusao + 'Z'),
              'dd/MM/yyyy HH:mm:ss',
              'America/Sao_Paulo'
            )
          );
        this.model
          .get('usuarioAdministriador')
          ?.setValue(await this.retornaNomeUsuario(fabricanteResponse.fabricante.idUsuarioAdmin));

        this.model.get('versao')?.enable();
        this.model.get('versaoResulth')?.enable();
        this.model.get('arquivo')?.enable();

        this._fabricanteResponse = fabricanteResponse;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  retornaNomeUsuario(idUsuarioAdmin: number): string {
    let nomeUsuario = '';
    this.usuarioAdminService.ObterPorId(idUsuarioAdmin).subscribe({
      next: (usuarioResponse: UsuarioAdminResponse) => {
        if (usuarioResponse.isError) {
          this.alertService.show('Erro', usuarioResponse.errorDescription, AlertType.error);
          return nomeUsuario;
        }

        if (usuarioResponse.usuarioAdmin) {
          nomeUsuario = usuarioResponse.usuarioAdmin.nomeUsuarioAdmin;
        }
        return nomeUsuario;
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error.message, AlertType.error);
      },
    });
    return nomeUsuario;
  }

  abreModalBase(): void {
    this.baseService.listaBase(this.idFabricante ?? 0, 0).subscribe({
      next: (listaBaseResponse: ListaBaseResponse) => {
        this._isLoading = false;
        if (listaBaseResponse.isError) {
          this.alertService.show('Erro', listaBaseResponse.errorDescription, AlertType.error);
          return;
        }

        const ultimaPagina = listaBaseResponse.listaBase?.length === 0;
        this.dialog.open(TableModalComponent, {
          width: '900px',
          data: {
            title: 'Bases',
            headers: {
              idBase: '#',
              descricaoTipoBase: 'Base',
              descricaoLinha: 'Linha',
              descricaoEmbalagem: 'Embalagem',
              densidade: 'Densidade',
              codigo: 'Codigo',
              descricao: 'Descricao',
            },
            rows: listaBaseResponse.listaBase,
            paginaAtual: 0,
            ultimaPagina: ultimaPagina,
            fetchMore: (pagina: number) => this.baseService.listaBase(this.idFabricante ?? 0, pagina),
            dataKey: 'listaBase',
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  abreModalPigmento(): void {
    this.pigmentoService.listaPigmento(this.idFabricante ?? 0, 0).subscribe({
      next: (listaPigmentoResponse: ListaPigmentoResponse) => {
        this._isLoading = false;
        if (listaPigmentoResponse.isError) {
          this.alertService.show('Erro', listaPigmentoResponse.errorDescription, AlertType.error);
          return;
        }
        const ultimaPagina = listaPigmentoResponse.listaPigmento?.length === 0;

        this.dialog.open(TableModalComponent, {
          width: '700px',
          data: {
            title: 'Pigmentos',
            headers: {
              idPigmento: '#',
              descricaoEmbalagem: 'Embalagem',
              codigo: 'Codigo',
              descricao: 'Descricao',
            },
            rows: listaPigmentoResponse.listaPigmento,
            paginaAtual: 0,
            ultimaPagina: ultimaPagina,
            fetchMore: (pagina: number) => this.pigmentoService.listaPigmento(this.idFabricante ?? 0, pagina),
            dataKey: 'listaPigmento',
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  abreModalEmbalagem(): void {
    this.embalagemService.listaEmbalagem(this.idFabricante ?? 0, 0).subscribe({
      next: (listaEmbalagemResponse: ListaEmbalagemResponse) => {
        this._isLoading = false;
        if (listaEmbalagemResponse.isError) {
          this.alertService.show('Erro', listaEmbalagemResponse.errorDescription, AlertType.error);
          return;
        }

        const ultimaPagina = listaEmbalagemResponse.listaEmbalagem?.length === 0;

        this.dialog.open(TableModalComponent, {
          width: '700px',
          data: {
            title: 'Embalagens',
            headers: {
              idEmbalagem: '#',
              codigo: 'Codigo',
              descricao: 'Descrição',
              volume: 'Volume',
            },
            rows: listaEmbalagemResponse.listaEmbalagem,
            paginaAtual: 0,
            ultimaPagina: ultimaPagina,
            fetchMore: (pagina: number) =>
              this.embalagemService.listaEmbalagem(this.idFabricante ?? 0, pagina),
            dataKey: 'listaEmbalagem',
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  abreModalCor(): void {
    this.corService.listaCor(this.idFabricante ?? 0, 0).subscribe({
      next: (listaCorResponse: ListaCorResponse) => {
        this._isLoading = false;
        if (listaCorResponse.isError) {
          this.alertService.show('Erro', listaCorResponse.errorDescription, AlertType.error);
          return;
        }

        const ultimaPagina = listaCorResponse.listaCor?.length === 0;

        this.dialog.open(TableModalComponent, {
          width: '950px',
          data: {
            title: 'Cores',
            headers: {
              idCor: '#',
              codigoUniversal: 'Código Universal',
              descricaoLinha: 'Linha',
              nome: 'Nome',
              descricao: 'Descrição',
              variacao: 'Variação',
              montadora: 'Montadora',
              camada: 'Camada',
              anoInicial: 'Ano Inicial',
              anoFinal: 'Ano Final',
            },
            rows: listaCorResponse.listaCor,
            paginaAtual: 0,
            ultimaPagina: ultimaPagina,
            fetchMore: (pagina: number) => this.corService.listaCor(this.idFabricante ?? 0, pagina),
            dataKey: 'listaCor',
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  abreModalFormula(): void {
    this.formulaService.listaFormula(this.idFabricante ?? 0, 0).subscribe({
      next: (listaFormulaResponse: ListaFormulaResponse) => {
        this._isLoading = false;
        if (listaFormulaResponse.isError) {
          this.alertService.show('Erro', listaFormulaResponse.errorDescription, AlertType.error);
          return;
        }

        const ultimaPagina = listaFormulaResponse.listaFormula?.length === 0;

        this.dialog.open(TableModalComponent, {
          width: '900px',
          data: {
            title: 'Fórmulas',
            headers: {
              idFormula: '#',
              descricaoCor: 'Cor',
              descricaoEmabalagem: 'Embalagem',
              descricaoTipoBase: 'Base',
              catalise: 'Catálise',
            },
            rows: listaFormulaResponse.listaFormula,
            paginaAtual: 0,
            ultimaPagina: ultimaPagina,
            fetchMore: (pagina: number) => this.formulaService.listaFormula(this.idFabricante ?? 0, pagina),
            dataKey: 'listaFormula',
          },
        });
      },
      error: (error: any) => {
        this.alertService.show('Erro inesperado', error, AlertType.error);
        this._isLoading = false;
      },
    });
  }

  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }
    this.model.get('versao')?.updateValueAndValidity();

    const objToken = sessionStorage.getItem('token');
    if (!objToken) {
      return;
    }

    const token: UsuarioAdminLoginResponse = JSON.parse(objToken);

    const fabricanteRequest: FabricanteRequest = new FabricanteRequest();

    fabricanteRequest.versao = this.model.get('versao')?.value;
    fabricanteRequest.versaoResulth = this.model.get('versaoResulth')?.value;
    fabricanteRequest.arquivo = this.model.get('arquivo')?.value;
    fabricanteRequest.idUsuarioAdmin = token.idUsuarioAdmin;
    this.alterar(fabricanteRequest);
  }

  private alterar(fabricanteRequest: FabricanteRequest): void {
    this._isLoading = true;
    this.fabricanteService.Alterar(this.idFabricante ?? 0, fabricanteRequest).subscribe({
      next: (returnStruct: ReturnStruct) => {
        this._isLoading = false;
        if (returnStruct.isError) {
          this.alertService.show('Erro', returnStruct.errorDescription, AlertType.error);
          return;
        }

        this.alertService.show('Sucesso', 'Fabricante alterado com sucesso.', AlertType.success);
        this.router.navigate(['/tintas/fabricante']);
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  selecionaArquivo(event: any): void {
    const file = event.target.files[0];
    if (file) {
      this.fileName = file.name;
      this.file = file;
    } else {
      this.fileName = '';
      this.file = null;
    }
    this.model.patchValue({ arquivo: file });
    this.model.get('arquivo')?.enable();
  }
}
